<template>
<div class="reportSample page">
  <BackBtn />
  <BreadCrumbs :items="breadcrumbs" />
  <div class="wrapper" v-if="serviceDetailReportSample">
    <div class="title pb-4">
      <h2>
        {{serviceDetailReportSample.text}}
      </h2>
    </div>
    <div>
      <v-img
        :src="serviceDetailReportSample.images[serviceDetailReportSample.images.length - 1].image_url"
        max-width="700px"
        :contain="true"
      />
    </div>
<!--    <div class="result">-->
<!--      <div class="description pb-2">-->
<!--        {{serviceDetailReportSample.description}}-->
<!--      </div>-->
<!--      <div class="test-value" v-for="value of serviceDetailReportSample.testValues" :key="value.id">-->
<!--        <div class="d-flex w-100 flex-column wrap">-->
<!--          <div class="labels">-->
<!--            <div class="left-label">-->
<!--              {{value.leftLabel}}-->
<!--            </div>-->
<!--            <div class="right-label">-->
<!--              {{value.rightLabel}}-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="progress w-100">-->
<!--            <v-progress-linear-->
<!--              v-model="value.value"-->
<!--              :color="value.color"-->
<!--              height="8px"-->
<!--              rounded-->

<!--              background-color="var(&#45;&#45;color-grey-200)"-->
<!--            ></v-progress-linear>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="count">-->
<!--          {{value.value}}-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
  </div>
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

/**
 * Компонент: _id
 * Описание:
 */
export default {
  name: '_id',

  components: {},

  props: {},

  data() {
    return {};
  },

  computed: {
    ...mapGetters({
      serviceDetailPreview: 'services/services/GET_DETAIL_SERVICE_PREVIEW',
      serviceDetailReportSample: 'services/services/GET_SERVICE_DETAIL_REPORT_SAMPLE',
      user: 'auth/user',
    }),
    breadcrumbs() {
      return [
        { title: 'Каталог услуг', url: '/admin-panel' },
        { title: `${this.serviceDetailPreview.name}`, url: `/list-services/${this.serviceDetailPreview.id}` },
        { title: 'Образец отчета', url: '' },
      ];
    },
  },

  watch: {},

  async created() {
    await this.GET_DETAIL_SERVICE(this.$route.params.id);
  },

  mounted() {
  },

  beforeDestroy() {
  },

  methods: {
    ...(mapActions(
      {
        GET_DETAIL_SERVICE: 'services/services/GET_DETAIL_SERVICE'
      }
    )),
  },
};
</script>

<style scoped lang="scss">
.reportSample {
  & .wrapper {
    display: flex;
    flex-direction: column;
    gap: 16px;
    & .result{
      padding: 24px;
      background: white;
      max-width: 830px;
      & .description{
        font-size: 14px;
      }
    }
    & .test-value{
      display: flex;
      align-items: flex-end;
      padding: 10px 0;
      gap: 16px;
      & .labels{
        display: flex;
        justify-content: space-between;
        padding-bottom: 8px;
      }
      & .progress{
        padding-bottom: 8px;
      }
    }
  }
  /* Стили компонента */
}
</style>
